var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromotions = function SvgPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "promotions_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".promotions_svg__st1{fill:none;stroke:#0054a6;stroke-width:14;stroke-linecap:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M-1.3.2H502v500.5H-1.3z",
    style: {
      fill: "#fd0"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promotions_svg__discount"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.2 107.9 3.8-5.4h85.7l57.2 81v204.8c0 5.3-4.3 9.5-9.5 9.5h-181c-5.3 0-9.5-4.3-9.5-9.5V183.5l26.6-37.7M293.4 243l-57.1 95.3",
    className: "promotions_svg__st1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.3,
    cy: 262.1,
    r: 19,
    className: "promotions_svg__st1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.4,
    cy: 319.2,
    r: 19,
    className: "promotions_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 136.8c9.8 5.8 13.1 18.5 7.3 28.3s-18.5 13.1-28.3 7.3c-6.3-3.7-10.2-10.5-10.2-17.8",
    className: "promotions_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6 179.4c-22.8-5-38-14.1-38-24.5 0-15.8 35.2-28.6 78.6-28.6s78.6 12.8 78.6 28.6",
    className: "promotions_svg__st1"
  }))));
};
export default SvgPromotions;